import React, { useCallback, useRef } from 'react';
import { View, Animated } from 'react-native';
import Selector from 'design-system/Selector';
import { AppView, rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import ClaimRewardsSection from 'features/rewards/components/ClaimRewardsSection';
import { isWeb } from '../../../constants';
const SECTIONS = ['Pending', 'Available'];
const ClaimRewardsList = ({ onChangeTab, redemptions, isFetching = false, selectedIndex, }) => {
    const { available, pending } = redemptions;
    const { contentWidth: screenWidth, paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const translateX = useRef(new Animated.Value(selectedIndex * -screenWidth)).current;
    const styles = useStyles(styleSet);
    const onChangeIndex = useCallback((index) => {
        onChangeTab(index);
        Animated.timing(translateX, {
            duration: 250,
            useNativeDriver: true,
            toValue: index * -screenWidth,
        }).start();
    }, [onChangeTab, screenWidth, translateX]);
    const pager = (<Animated.View style={[
            styles.pager,
            {
                transform: [{ translateX }],
                width: screenWidth * 2,
            },
        ]}>
      <View style={[styles.listContainer, { width: screenWidth }]}>
        {!isFetching ? (<ClaimRewardsSection data={pending} tabLabel="Pending"/>) : null}
      </View>
      <View style={[styles.listContainer, { width: screenWidth }]}>
        {!isFetching ? (<ClaimRewardsSection data={available} tabLabel="Available"/>) : null}
      </View>
    </Animated.View>);
    return (<AppView withFrame={false} style={styles.content}>
      <View style={[styles.selectorContainer, paddingHorizontalStyle]}>
        <Selector Text-14 sections={SECTIONS} onSelected={onChangeIndex} defaultIndex={selectedIndex}/>
      </View>
      <View style={styles.pagerClip}>{pager}</View>
    </AppView>);
};
const styleSet = createStyleSheets(() => ({
    content: {
        flex: 1,
        marginHorizontal: 0,
        marginVertical: 0,
        paddingTop: rem(12),
    },
    pager: {
        position: 'relative',
        flexDirection: 'row',
        flex: 1,
    },
    listContainer: {
        flex: 1,
    },
    pagerClip: {
        flex: 1,
        overflow: 'hidden',
    },
    selectorContainer: {
        alignItems: 'center',
        marginHorizontal: rem(16),
    },
    button: {
        paddingHorizontal: rem(16),
    },
}));
export default ClaimRewardsList;
